
import "./Loader.scss";

const Loader = () =>  {

return (
    <div className="loader">
      <div>
     <div className="container">
  <div className="glitch" data-text="CyberNotes">CyberNotes</div>
  <div className="glow">CyberNotes</div>
  <p className="subtitle">WELCOME-TO</p>
  </div>
  <div className="scanlines"></div>
  </div>
    </div>
  )
}

export default Loader;